import { render } from "./Switch.vue?vue&type=template&id=b872ddfc"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=b872ddfc&lang=css"
script.render = render

export default script